import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfigurationModule } from './configuration/configuration.module';
import { ConfigurationComponent } from './configuration/configuration.component';
import { AccountsModule } from './accounts/accounts.module';
import { AccountsComponent } from './accounts/accounts.component';
import { ReportsModule } from './reports/reports.module';
import { ReportsComponent } from './reports/reports.component';
import { routes as r1 } from './accounts/accounts-routing.module';

export const routableModules = [
  ConfigurationModule
  ,AccountsModule
  ,ReportsModule
]

export const routes: Routes = [
  { path: 'configuration', component: ConfigurationComponent},
  { path: 'accounts', component: AccountsComponent, children: r1}, //loadChildren:'app/admin/accounts/accounts-routing.module#AccountsRoutingModule' },
  { path: 'reports', component: ReportsComponent},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
    ,routableModules
  ],
  exports: [RouterModule]
})
export class AdminRoutingModule { }

